import { getSupportedPaymentMethodsForCaja } from '@seek/payments-widget';

import { getPriceVisibility } from 'src/app/v1/dataAnalytics/utils/getPriceVisibility';
import type { Tealium } from 'src/types/appState';

import { EVENT_VIEW_PAY_AND_POST } from '../constants';

const isRepeatHirer = (hirerType: string) => hirerType.search('repeat') !== -1;

export const eventName = EVENT_VIEW_PAY_AND_POST;

export default (tealium: Tealium) => {
  const {
    country,
    draftId,
    hirerAdPurchaser,
    isOnCreditHold,
    jobAdTypeSelected,
    priceVisibility,
    productSetId,
    productSetProductIds,
    hasSufficientBudget,
    isPaidByStoredCreditCard,
    isPayment,
  } = tealium;
  {
    const paymentMethods = getSupportedPaymentMethodsForCaja(
      country.toUpperCase(),
    );

    return {
      adProductSetId: productSetId,
      adProductName: [jobAdTypeSelected],
      isPriceHidden: getPriceVisibility(priceVisibility),
      isHirerRepeatAdPurchaser: isRepeatHirer(hirerAdPurchaser),
      productTransactionId: draftId ?? null,
      productSetProductIds,
      isCreditHoldMessageViewed: isOnCreditHold,
      paymentMethodShown: paymentMethods,
      hasSufficientBudget,
      actionOrigin: 'caja',
      isPaidByStoredCreditCard,
      isPayment,
    };
  }
};
